var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    width: "78.221886mm",
    height: "78.221886mm",
    viewBox: "0 0 78.221886 78.221886",
    id: "svg3108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3105"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-51.202763,-72.621029)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 6.51007,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path42322",
    cx: 90.313705,
    cy: 111.73197,
    rx: 35.855999,
    ry: 35.855907
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 94.517583,119.47126 5.002862,-5.00286 14.141595,14.14146 -5.00285,5.00286 z m 8.767137,-12.1974 c 4.55166,0 8.25437,-3.70263 8.25437,-8.254371 0,-1.367884 -0.37704,-2.641373 -0.96695,-3.773403 l -6.36771,6.367624 -3.51402,-3.514017 6.36771,-6.367624 c -1.13203,-0.589191 -2.40561,-0.966949 -3.7734,-0.966949 -4.551745,0 -8.25442,3.702717 -8.25442,8.254369 0,0.96695 0.188705,1.886741 0.495231,2.735771 l -4.363017,4.36304 -4.197947,-4.19796 1.674462,-1.67451 -3.32535,-3.325321 4.99981,-4.999738 c -2.759337,-2.75939 -7.240282,-2.75939 -9.999605,0 l -8.348715,8.348679 3.325331,3.32531 h -6.650673 l -1.674459,1.67451 8.34872,8.34868 1.674462,-1.67442 v -6.67426 l 3.325334,3.32532 1.674461,-1.67442 4.197947,4.19786 -17.475709,17.47579 4.999794,4.99974 26.838573,-26.81494 c 0.84947,0.30663 1.76882,0.4956 2.73577,0.4956 z",
    id: "path2",
    style: {
      strokeWidth: 0.264583
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool);
export default __webpack_public_path__ + "static/media/tool.16e98b06a8cceeab140e6d3381de2b00.svg";
export { ForwardRef as ReactComponent };